import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { adminRoute } from './_admin';

const MaintenancePage = lazy(() => import('@/pages/admin/MaintenancePage'));

/**
 * Admin maintenance route - /admin/maintenance
 * Provides storage integrity tools (orphaned R2 detection)
 */
export const adminMaintenanceRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: 'maintenance',
  component: MaintenancePage,
});

// Backward compatibility
export const Route = adminMaintenanceRoute;
